import {
  AssetApi,
  Configuration,
  type ConfigurationParameters,
  RelationApi,
  SettingApi,
  SniApi,
  WebsiteConfigurationApi
} from './hau-itde-spareparts-purchase-shop-portal-api';
import { PimApi } from './hau-itde-spareparts-purchase-shop-portal-api/api/pim-api';

//create portal api config
const configParams: ConfigurationParameters = {
  basePath: import.meta.env.VITE_PORTAL_API_BASE_URL
};
const config = new Configuration(configParams);

/**
 * Use this export for api access
 * @exports ReachApi callable configured reach api
 */
export const sniApi = new SniApi(config);
export const pimApi = new PimApi(config);
export const assetApi = new AssetApi(config);
export const relationApi = new RelationApi(config);
export const settingApi = new SettingApi(config);
export const websiteConfigurationApi = new WebsiteConfigurationApi(config);
